import axios from '../index';

// 账户登录认证
export const loginSubmit = (data) => {
  return axios.post('/api/loginByName', data);
};

// 账户登录认证 Token
export const loginSubmitByToken = (token) => {
  return axios.get('/api/loginByHelpToken?token=' + token);
};
